<script setup>
import { computed } from 'vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  itemsByStage: {
    type: Object,
    required: true,
  },
});

const topStages = computed(() => {
  const stages = Object.entries(props.itemsByStage || {})
    .map(([name, count]) => ({ name, count }))
    .sort((a, b) => b.count - a.count)
    .slice(0, 5);

  const maxCount = Math.max(...stages.map(s => s.count), 1);

  return stages.map(stage => ({
    ...stage,
    percentage: Math.round((stage.count / maxCount) * 100),
  }));
});
</script>

<template>
  <div class="p-5 rounded-lg border border-n-weak bg-n-solid-2">
    <div class="flex items-center justify-between mb-5">
      <h3 class="text-sm font-medium text-n-slate-12">
        {{ $t('PIPELINE.DASHBOARD.CHARTS.ITEMS_BY_STAGE') }}
      </h3>
    </div>
    <div class="space-y-4">
      <div v-for="stage in topStages" :key="stage.name">
        <div class="flex items-center justify-between mb-1.5">
          <span class="text-sm text-n-slate-11">
            {{ stage.name }}
          </span>
          <span
            class="text-sm font-medium text-n-slate-12 bg-n-alpha-2 px-2 py-0.5 rounded"
          >
            {{ stage.count }}
          </span>
        </div>
        <div class="w-full h-1.5 bg-n-alpha-2 rounded-full overflow-hidden">
          <div
            class="h-full bg-n-brand rounded-full transition-all duration-500"
            :style="{ width: `${stage.percentage}%` }"
          />
        </div>
      </div>
      <div
        v-if="topStages.length === 0"
        class="flex flex-col items-center justify-center py-12"
      >
        <Icon icon="i-lucide-trending-up" class="size-10 text-n-slate-9 mb-2" />
        <p class="text-sm text-n-slate-11">
          {{ $t('PIPELINE.DASHBOARD.NO_DATA') }}
        </p>
      </div>
    </div>
  </div>
</template>
